module.exports = __webpack_public_path__ + "img/sys.e02dcbcb.png";